import React from 'react'
import { FacebookShareButton, VKShareButton } from 'react-share'
import cn from 'classnames'

import css from './share.module.scss'
import imgShareFB from './img/share-fb.svg'
import imgShareVK from './img/share-vk.svg'

export default function() {
  return (
    <div className={css.share}>
      <span className={cn(css.text, 'body-text')}>Поделиться:</span>
      {{/*
      <div className={css.button}>
        <FacebookShareButton url={window.location.href}>
          <img src={imgShareFB}/>
        </FacebookShareButton>
      </div>
      */}}
      <div className={css.button}>
        <VKShareButton url={window.location.href}>
          <img src={imgShareVK}/>
        </VKShareButton>
      </div>
    </div>
  )
}